// Schema.org structured data — injected via <JsonLd> for SEO rich snippets.

export const SITE_URL = "https://ayapay.ch";
export const BRAND = "AyaPay";
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_payment-links-hub-1/artifacts/qmtwufa4_test%20logo%20.jpg";

// Organization — used on home & global
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: BRAND,
  legalName: "AyaPay SA",
  url: SITE_URL,
  logo: LOGO_URL,
  image: LOGO_URL,
  description: "AyaPay — Solutions de paiement pour commerçants suisses. Terminal de paiement 100% gratuit, Twint, Apple Pay, NFC. Assurance et support 24/7 inclus.",
  email: "contact@ayapay.ch",
  telephone: "+41762003612",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Chemin des Lilas 12",
    postalCode: "2503",
    addressLocality: "Biel/Bienne",
    addressRegion: "BE",
    addressCountry: "CH",
  },
  sameAs: [
    "https://www.linkedin.com/company/ayapay",
    "https://ayapos.com",
  ],
  contactPoint: [{
    "@type": "ContactPoint",
    telephone: "+41762003612",
    contactType: "customer service",
    email: "contact@ayapay.ch",
    areaServed: "CH",
    availableLanguage: ["French", "German", "Italian", "English", "Portuguese", "Turkish"],
  }],
};

// LocalBusiness / FinancialService — for local SEO (Google Maps, "near me")
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "FinancialService",
  "@id": `${SITE_URL}/#localbusiness`,
  name: BRAND,
  image: LOGO_URL,
  logo: LOGO_URL,
  url: SITE_URL,
  telephone: "+41762003612",
  email: "contact@ayapay.ch",
  priceRange: "Terminal gratuit · Frais sur mesure",
  description: "Terminal de paiement 100% gratuit pour commerçants suisses. Twint, Apple Pay, NFC, support 24/7 inclus.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Chemin des Lilas 12",
    postalCode: "2503",
    addressLocality: "Biel/Bienne",
    addressRegion: "BE",
    addressCountry: "CH",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 47.1368,
    longitude: 7.2467,
  },
  areaServed: [
    { "@type": "Country", name: "Switzerland" },
    { "@type": "City", name: "Geneva" },
    { "@type": "City", name: "Lausanne" },
    { "@type": "City", name: "Zurich" },
    { "@type": "City", name: "Bern" },
    { "@type": "City", name: "Basel" },
    { "@type": "City", name: "Biel/Bienne" },
  ],
  openingHoursSpecification: [{
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "08:00",
    closes: "18:00",
  }],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    reviewCount: "187",
  },
};

// Website with SearchAction (for Sitelinks Searchbox)
export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: BRAND,
  inLanguage: ["fr-CH", "de-CH", "it-CH", "pt-PT", "en-US", "tr-TR"],
  publisher: { "@id": `${SITE_URL}/#organization` },
};

// Breadcrumb helper
export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

// Product (Terminal) helper
export const productSchema = (terminal) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: `Terminal de paiement ${terminal.name}`,
  image: terminal.image,
  description: terminal.description || `Terminal de paiement ${terminal.name} certifié PCI PTS 6 — mis à disposition gratuitement par AyaPay.`,
  brand: { "@type": "Brand", name: BRAND },
  manufacturer: { "@type": "Organization", name: "Adyen" },
  category: "Payment Terminal",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "CHF",
    availability: "https://schema.org/InStock",
    seller: { "@type": "Organization", name: BRAND },
    description: "Terminal mis à disposition gratuitement. Frais uniquement sur les transactions.",
  },
});

// FAQ helper
export const faqSchema = (questions) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: questions.map((q) => ({
    "@type": "Question",
    name: q.q,
    acceptedAnswer: { "@type": "Answer", text: q.a },
  })),
});

// Service schema for landing pages
export const serviceSchema = (name, description, city = null) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "Payment Terminal Service",
  name,
  description,
  provider: { "@id": `${SITE_URL}/#organization` },
  areaServed: city
    ? { "@type": "City", name: city, address: { "@type": "PostalAddress", addressCountry: "CH" } }
    : { "@type": "Country", name: "Switzerland" },
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "CHF",
    description: "Terminal de paiement gratuit, frais uniquement sur transactions.",
  },
});
